/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable no-restricted-syntax */
import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {
  channel_type_enum,
  channel_type_style,
} from 'hiya-common/src/reducers/commonTypes'

export {channel_type_enum} from 'hiya-common/src/reducers/commonTypes'
export enum historyType {
  提现 = 101,
  薪资扣除 = 102,
  余额转金币 = 103,
  结算薪资 = 201,
  重新结算薪资 = 202,
  提现失败 = 203,
  审核失败 = 204,
}
export enum historyStatus {
  待审核 = 1,
  待打款 = 2,
  审核未通过 = 3,
  已到账 = 4,
  提现失败 = 5,
}
export interface historyListType {
  type: historyType
  time: string
  money: number
  status: number
  status_desc?: string
  show_money: string
  title?: string
  reason?: string
  operate_t?: string
}
// 各种渠道绑定的类型
// 6 他人代收
// 7 payermax_gcash
// 8 公会长代收
// export enum channel_type_enum {
//   Identity = 1,
//   Payoneer = 2,
//   PayerMaxBank = 3,
//   AirWallexBank = 4,
//   PayerMaxFawry = 5,
//   他人代收 = 6,
//   PayermaxGcash = 7,
//   公会长代收 = 8,
//   NormalCoin = 1000,
//   TraderCoin = 1001,
// }

// 金币交易
export enum COIN_TRADE {
  NormalCoin = 1, // 普通金币
  TraderCoin = 2, // 币商金币
}

// payoneer 绑定状态
// 0未绑定 1生效中 2待确认 3被拒绝 4未找到
export enum PAYONEER_BIND_STATUS {
  未绑定 = 0,
  生效中 = 1,
  待确认 = 2,
  被拒绝 = 3,
  未找到 = 4,
}

// 银行分类
export enum BANK_TYPE {
  Payoneer = 2,
  PayerMaxBank = 3,
  AirWallexBank = 4,
  GCash = 7,
}

// 银行绑定状态
export enum BANK_STATUS {
  UnDetail = 0, // 0未填写
  Check = 1, // 1审核中
  Pass = 2, // 2审核通过
  Reject = 3, // 3审核拒绝
  Delete = 4, // 4删除
}

// 提现方式
export enum WITHDRAW_TYPE {
  NormalCoin = 1,
  TraderCoin = 2,
  Payoneer = 3, // Payoneer提现
  PayerMax = 4, // PayerMax提现
  AirWallex = 5, // AirWallex提现
  UnionReceive = 6, // 公会长代收
}

// app工会长薪资转金币页面配置信息 http://wiki.xunlei.cn/pages/viewpage.action?pageId=90607041
export const wage_to_coins_cfg = createAsyncThunk(
  'SalaryWallet/wage_to_coins_cfg',
  async (arg, store: any) => {
    const resp = await http.post<HiyaRes<Pick<InitialStateType, 'wallet'>>>(
      '/live/union/wage_to_coins_cfg',
      {
        ...store.getState().env.deviceinfo,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

// 公会长薪资转金币 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=41449707
export const wage_to_coins = createAsyncThunk(
  'withdraw_union_leader_wage_to_coins',
  async (arg: any, store: any) => {
    const resp = await http.post(
      '/live/union/wage_to_coins',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

// 获取绑定渠道信息  http://wiki.xunlei.cn/pages/viewpage.action?pageId=105290331
export const get_pay_channel = createAsyncThunk(
  'SalaryWallet/get_pay_channel',
  async (arg, store: any) => {
    const resp = await http.post('/live/union/get_pay_channel', {
      ...store.getState().env.deviceinfo,
      target_mid: store.getState().env.deviceinfo.h_m,
      only_need_pass: false,
    })
    return resp.data.data
  }
)
export enum rate_kind_enum {
  实时 = 1,
  固定 = 2,
}
export enum fee_kind_enum {
  固定金额 = 1,
  最低加固定比例 = 2,
}

// 银行提现 http://wiki.xunlei.cn/pages/viewpage.action?pageId=105285961
export const wage_to_channel = createAsyncThunk(
  'SalaryWallet/wage_to_channel',
  async (arg: any, store: any) => {
    const resp = await http.post<
      HiyaRes<{
        channel_type: channel_type_enum
        err_msg?: string
        msg?: string
        op_money?: number // 提取的薪资数
        currency?: string // 到账币种
        rate_kind?: rate_kind_enum // 汇率类型 1实时 2配置(固定)
        fixed_rate?: number // 固定汇率
        fixed_money?: number // 固定汇率下的到账金额
        fee_kind?: fee_kind_enum // 手续费模式 1固定金额 2最低+固定比例
        fee_currency?: string // 手续费币种
        fee_fixed_money?: number // 固定手续费
        fee_rate?: number // 固定手续费比例
        fee_min_money?: number // 最低手续费
      }>
    >(
      '/live/union/wage_to_channel',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

// 获取公会长信息
export const union_owner_info_by_mid = createAsyncThunk(
  'SalaryWallet/union_owner_info_by_mid',
  async (arg, store: any) => {
    const resp = await http.post('/live/union/union_owner_info_by_mid', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data.data
  }
)

// 获取代收信息 http://wiki.xunlei.cn/pages/viewpage.action?pageId=105294321
export const getWalletLog = createAsyncThunk(
  'SalaryWallet/getWalletLog',
  async (arg, store: any) => {
    const resp = await http.post('/live/union/app_wallet_log', {
      ...store.getState().env.deviceinfo,
      kind: 3,
      offset: 0,
      page_size: 10,
    })
    return resp.data.data
  }
)

interface InitialStateType {
  wallet: {
    // 总余额 -----
    total_balance?: number
    // 是否暂时new ---
    is_new?: boolean
    // 可提现的余额
    balance?: number
    // app中审核的余额
    auditing_balance?: number
    // 币商金币 最小的转换数
    divide_money?: number
    // 普通金币 允许的最少转换数（美元）
    min_money?: number

    // 薪资转金币开关
    wage_to_coins_switch?: boolean
    // 币商配置列表
    ra_ratio_list?: Array<{range: string; ratio: string}>
    // 普通配置列表
    ratio_list?: Array<{range: string; ratio: string}>

    err_msg?: string
    money?: number
    coins?: number
  }
  bindList: {
    default_channel?: number
    list?: {
      [key: string]: any
      style?: channel_type_style
    }[]
    is_cashout_time?: boolean
  }
  unionInfo: any
}

const initialState: InitialStateType = {
  wallet: {},
  bindList: {
    default_channel: 8,
    list: [],
    is_cashout_time: false,
  },
  unionInfo: {},
}

export const SalaryWalletSlice = createSlice({
  name: 'SalaryWallet',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(wage_to_coins_cfg.fulfilled, (state, action) => {
      Object.assign(state.wallet, action.payload)
    })
    builder.addCase(get_pay_channel.fulfilled, (state, action) => {
      Object.assign(state.bindList, action.payload)
    })
    builder.addCase(union_owner_info_by_mid.fulfilled, (state, action) => {
      Object.assign(state.unionInfo, action.payload)
    })
  },
})
export default SalaryWalletSlice.reducer
// export const SalaryWalletActions = SalaryWalletSlice.actions
